<template>
  <section id="page-foobar-detail">
    <div class="container">
      <div class="row">
        <clearfix :biggest="true"></clearfix>
      </div>

      <div class="row" v-show="loading">
        <div class="col-sm-12 content fb-bg-light">
          <loading-spinner></loading-spinner>
        </div>
      </div>

      <div class="row" v-show="!loading">
        <div class="col-sm-12 content fb-bg-dark">
          <h3>{{ foobar.title }}</h3>
        </div>

        <clearfix :wide="true"></clearfix>

        <div class="col-sm-12 content fb-bg-light">
          <div v-html="foobar.description"></div>
        </div>

        <clearfix :wide="true"></clearfix>

        <div class="col-sm-12 content fb-bg-light">
          <div>
            <vue-markdown :source="foobar.md" lang-prefix="hljs "></vue-markdown>
          </div>
        </div>
      </div>

      <div class="row" v-show="!loading && foobar.snippets.length > 0" v-for="snippet in sortedSnippets">
        <clearfix :wide="true"></clearfix>

        <div class="col-sm-12 content fb-bg-light">
          <a :name="snippet.id"></a>
          <h4 v-show="snippet.title.length > 0">{{snippet.title}}</h4>
          <div>
            <pre v-highlightjs="snippet.content"><code :class="snippet.lang"></code></pre>
          </div>
        </div>
      </div>

      <clearfix :wide="true"></clearfix>

      <div class="row" v-show="!loading && foobar.tags.length > 0" >
        <clearfix :wide="true"></clearfix>

        <div class="col-sm-12 content fb-bg-light">
          <div>
            <span>{{ $t('message.title.tags') }}:&nbsp;</span><b-button :size="'sm'" :variant="'secondary'" v-for="tag in foobar.tags" class="fb-tag">{{ tag }}</b-button>
          </div>
        </div>
      </div>

      <clearfix :biggest="true"></clearfix>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue'
  import VueMarkdown from 'vue-markdown'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import 'vue-awesome/icons'
  import Icon from 'vue-awesome/components/Icon.vue'
  import Clearfix from '@/components/utils/Clearfix'
  import LoadingSpinner from '@/components/utils/LoadingSpinner'
  import config from './Config'

  Vue.use(VueAxios, axios)

  export default {
    props: {
      foobarId: String
    },
    components: {
      Clearfix, LoadingSpinner, Icon, VueMarkdown
    },
    data() {
      return {
        foobar: {snippets: []},
        loading: true
      }
    },
    computed: {
      sortedSnippets() {
        return this.foobar.snippets.sort((s1, s2) => {
          return s1.order > s2.order
        })
      }
    },
    created() {
      Vue.axios.get(config.urls.foobar + this.foobarId)
        .then((response) => {
          this.foobar = response.data
          this.loading = false
        })
    }
  }
</script>

<style>
  #page-foobar-detail {
    background: url('../../assets/img/bg/coding.jpg') center fixed no-repeat;
    background-size: cover;
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// Foobar.vue?1cb390e0